import React, { createContext, useContext } from "react";
import { Notifier } from "@airbrake/browser";

const projectId = import.meta.env.VITE_AIRBRAKE_PROJECT_ID;
const projectKey = import.meta.env.VITE_AIRBRAKE_PROJECT_KEY;

function createAirbrake() {
  if (!projectId || !projectKey) {
    return {
      notify: () => {},
      addFilter: () => {},
    };
  }

  const airbrake = new Notifier({
    projectId,
    projectKey,
    environment: process.env.NODE_ENV,
  });

  airbrake.addFilter((notice) => {
    if (process.env.NODE_ENV === "development") {
      return null;
    }
    return notice;
  });

  return airbrake;
}

const airbrake = createAirbrake();

const AirbrakeContext = createContext(null);

export const AirbrakeProvider = ({ children }) => {
  return (
    <AirbrakeContext.Provider value={airbrake}>
      {children}
    </AirbrakeContext.Provider>
  );
};

export const useAirbrake = () => {
  const context = useContext(AirbrakeContext);
  if (context === null) {
    throw new Error("useAirbrake must be used within an AirbrakeProvider");
  }
  return context;
};
